module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nezet.tipus == 'kitoltesek'),
      expression: "nezet.tipus == 'kitoltesek'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("\n            Rendszeres szociális ösztöndíj pályázataim\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "article-text"
  }, _vm._l((_vm.kitoltesek), function(kitoltes, i) {
    return _c('div', {
      staticClass: "info-box"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(kitoltes.tanulmanyiFelev))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "column",
        "align-items": "flex-start"
      }
    }, [(kitoltes.tanulmanyiFelev != '2023/2024/1' && ![0].includes(parseInt(kitoltes.statusz))) ? _c('button', {
      staticClass: "button",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "disabled": _vm.pdf_generalas_folyamatban,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.pdfGeneralas(kitoltes.id, 1)
        }
      }
    }, [_vm._v("Beadott pályázatom (Pdf)")]) : _vm._e(), _vm._v(" "), ([4, 6].includes(parseInt(kitoltes.statusz))) ? _c('button', {
      staticClass: "button",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "disabled": _vm.pdf_generalas_folyamatban,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.pdfGeneralas(kitoltes.id, 0)
        }
      }
    }, [_vm._v("Elbírált pályázatom (" + _vm._s(kitoltes.osszPontszam) + " pont) (Pdf)")]) : _vm._e(), _vm._v(" "), (kitoltes.email != false) ? _c('button', {
      staticClass: "button with-icon",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "type": "button",
        "disabled": _vm.pdf_generalas_folyamatban
      },
      on: {
        "click": function($event) {
          _vm.emailPopupNyit(kitoltes.email)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-envelope"
    }), _vm._v("Email tartalma")]) : _vm._e(), _vm._v(" "), ([0].includes(parseInt(kitoltes.statusz))) ? _c('div', [_vm._v("Nem található végelegesített pályázat.")]) : _vm._e()])])
  })), _vm._v(" "), (_vm.tanulmanyiFelev != false) ? _c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("\n              Rendszeres szociális ösztöndíj " + _vm._s(_vm.tanulmanyiFelev) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "article-text"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "flex-start"
    }
  }, [(_vm.aktiv_idoszak_kitoltes != false && ![0].includes(parseInt(_vm.aktiv_idoszak_kitoltes.statusz))) ? _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.pdf_generalas_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pdfGeneralas(_vm.aktiv_idoszak_kitoltes.id, 1)
      }
    }
  }, [_vm._v("Beadott pályázatom (Pdf)")]) : _vm._e(), _vm._v(" "), (_vm.aktiv_idoszak_kitoltes != false && [4, 6].includes(parseInt(_vm.aktiv_idoszak_kitoltes.statusz))) ? _c('button', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "disabled": _vm.pdf_generalas_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pdfGeneralas(_vm.aktiv_idoszak_kitoltes.id, 0)
      }
    }
  }, [_vm._v("Elbírált pályázatom (" + _vm._s(_vm.aktiv_idoszak_kitoltes.osszPontszam) + " pont) (Pdf)")]) : _vm._e(), _vm._v(" "), (_vm.aktiv_idoszak_kitoltes != false && _vm.aktiv_idoszak_kitoltes.email != false) ? _c('button', {
    staticClass: "button with-icon",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "disabled": _vm.pdf_generalas_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.emailPopupNyit(_vm.aktiv_idoszak_kitoltes.email)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v("Email tartalma")]) : _vm._e(), _vm._v(" "), (_vm.aktiv_idoszak_kitoltes == false && _vm.k_kitoltes) ? _c('button', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "disabled": _vm.pdf_generalas_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.palyazatElfogadas()
      }
    }
  }, [_vm._v(_vm._s(_vm.tanulmanyiFelev) + "/K pályázat eredményének elfogadása")]) : _vm._e(), _vm._v(" "), (_vm.aktiv_idoszak_kitoltes == false && _vm.k_kitoltes) ? _c('button', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "disabled": _vm.pdf_generalas_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.palyazatModositasa()
      }
    }
  }, [_vm._v(_vm._s(_vm.tanulmanyiFelev) + "/K pályázat módosítása")]) : _vm._e(), _vm._v(" "), (_vm.aktiv_idoszak_kitoltes == false || (_vm.aktiv_idoszak_kitoltes != false && [0].includes(parseInt(_vm.aktiv_idoszak_kitoltes.statusz)))) ? _c('button', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "disabled": _vm.pdf_generalas_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.palyazatUrlapMegjelenites()
      }
    }
  }, [_vm._v("Új pályázat leadása")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.aktiv_hianypotlas_idoszak != false && _vm.hianypotlasra_varo_kitoltes !== false) ? _c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("\n              Rendszeres szociális ösztöndíj " + _vm._s(_vm.aktiv_hianypotlas_idoszak) + " hiánypótlás\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "article-text"
  }, [_vm._v("\n              Az Ön pályázatához hiánypótlás szükséges.\n              "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "flex-start",
      "padding-top": "20px"
    }
  }, [_c('button', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "disabled": _vm.pdf_generalas_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hianypotlasUrlapMegjelenites()
      }
    }
  }, [_vm._v("Hiánypótlás űrlap megnyitása")])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nezet.tipus == 'urlap'),
      expression: "nezet.tipus == 'urlap'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "nev",
      "name": "nev",
      "disabled": "",
      "label": "Név"
    },
    model: {
      value: (_vm.form.nev),
      callback: function($$v) {
        _vm.form.nev = $$v
      },
      expression: "form.nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "neptunkod",
      "name": "neptunkod",
      "disabled": "",
      "label": "Neptun azonosító"
    },
    model: {
      value: (_vm.form.neptunkod),
      callback: function($$v) {
        _vm.form.neptunkod = $$v
      },
      expression: "form.neptunkod"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "szuletesiHely",
      "name": "szuletesiHely",
      "disabled": "",
      "label": "Születési hely"
    },
    model: {
      value: (_vm.form.szuletesiHely),
      callback: function($$v) {
        _vm.form.szuletesiHely = $$v
      },
      expression: "form.szuletesiHely"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "szuletesiIdo",
      "name": "szuletesiIdo",
      "disabled": "",
      "label": "Születési idő"
    },
    model: {
      value: (_vm.form.szuletesiIdo),
      callback: function($$v) {
        _vm.form.szuletesiIdo = $$v
      },
      expression: "form.szuletesiIdo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "anyjaNeve",
      "name": "anyjaNeve",
      "disabled": "",
      "label": "Anyja neve"
    },
    model: {
      value: (_vm.form.anyjaNeve),
      callback: function($$v) {
        _vm.form.anyjaNeve = $$v
      },
      expression: "form.anyjaNeve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "telefonszam",
      "name": "telefonszam",
      "disabled": "",
      "label": "Telefonszám"
    },
    model: {
      value: (_vm.form.telefonszam),
      callback: function($$v) {
        _vm.form.telefonszam = $$v
      },
      expression: "form.telefonszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "emailCim",
      "name": "emailCim",
      "disabled": "",
      "label": "E-mail cím"
    },
    model: {
      value: (_vm.form.emailCim),
      callback: function($$v) {
        _vm.form.emailCim = $$v
      },
      expression: "form.emailCim"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Képzések",
      "id": "kivalasztottKepzesKodja",
      "options": _vm.kepzesek
    },
    on: {
      "onChange": _vm.kepzesValt
    },
    model: {
      value: (_vm.form.kivalasztottKepzesKodja),
      callback: function($$v) {
        _vm.form.kivalasztottKepzesKodja = $$v
      },
      expression: "form.kivalasztottKepzesKodja"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kar",
      "name": "kar",
      "disabled": "",
      "label": "Kar neve"
    },
    model: {
      value: (_vm.form.kar),
      callback: function($$v) {
        _vm.form.kar = $$v
      },
      expression: "form.kar"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tagozat",
      "name": "tagozat",
      "disabled": "",
      "label": "Tagozat"
    },
    model: {
      value: (_vm.form.tagozat),
      callback: function($$v) {
        _vm.form.tagozat = $$v
      },
      expression: "form.tagozat"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesNeve",
      "name": "kepzesNeve",
      "disabled": "",
      "label": "Képzés"
    },
    model: {
      value: (_vm.form.kepzesNeve),
      callback: function($$v) {
        _vm.form.kepzesNeve = $$v
      },
      expression: "form.kepzesNeve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesKodja",
      "name": "kepzesKodja",
      "disabled": "",
      "label": "Képzés kódja"
    },
    model: {
      value: (_vm.form.kepzesKodja),
      callback: function($$v) {
        _vm.form.kepzesKodja = $$v
      },
      expression: "form.kepzesKodja"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesSzintje",
      "name": "kepzesSzintje",
      "disabled": "",
      "label": "Képzés szintje"
    },
    model: {
      value: (_vm.form.kepzesSzintje),
      callback: function($$v) {
        _vm.form.kepzesSzintje = $$v
      },
      expression: "form.kepzesSzintje"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "hallgatoiStatusz",
      "name": "hallgatoiStatusz",
      "disabled": "",
      "label": "Hallgatói státusz"
    },
    model: {
      value: (_vm.form.hallgatoiStatusz),
      callback: function($$v) {
        _vm.form.hallgatoiStatusz = $$v
      },
      expression: "form.hallgatoiStatusz"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesHelye",
      "name": "kepzesHelye",
      "disabled": "",
      "label": "Képzés helye"
    },
    model: {
      value: (_vm.form.kepzesHelye),
      callback: function($$v) {
        _vm.form.kepzesHelye = $$v
      },
      expression: "form.kepzesHelye"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "penzugyiStatusz",
      "name": "penzugyiStatusz",
      "disabled": "",
      "label": "Pénzügyi státusz"
    },
    model: {
      value: (_vm.form.penzugyiStatusz),
      callback: function($$v) {
        _vm.form.penzugyiStatusz = $$v
      },
      expression: "form.penzugyiStatusz"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "osztondijindex",
      "name": "osztondijindex",
      "disabled": "",
      "label": "Ösztöndíjindex"
    },
    model: {
      value: (_vm.form.osztondijindex),
      callback: function($$v) {
        _vm.form.osztondijindex = $$v
      },
      expression: "form.osztondijindex"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "display": "none"
    }
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "szakatlag",
      "name": "szakatlag",
      "disabled": "",
      "label": "Szakátlag"
    },
    model: {
      value: (_vm.form.szakatlag),
      callback: function($$v) {
        _vm.form.szakatlag = $$v
      },
      expression: "form.szakatlag"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper",
    class: {
      disabled: _vm.alaptamogatasDisabled()
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.alapTamogatas),
      expression: "form.alapTamogatas"
    }],
    attrs: {
      "disabled": _vm.alaptamogatasDisabled(),
      "id": "alapTamogatas",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.alapTamogatas) ? _vm._i(_vm.form.alapTamogatas, "1") > -1 : _vm._q(_vm.form.alapTamogatas, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.alapTamogatas,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.alapTamogatas = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.alapTamogatas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.alapTamogatas = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper",
    class: {
      disabled: _vm.rendszeresSzocialisOsztondijDisabled()
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.rendszeresSzocialisOsztondij),
      expression: "form.rendszeresSzocialisOsztondij"
    }],
    attrs: {
      "disabled": _vm.rendszeresSzocialisOsztondijDisabled(),
      "id": "rendszeresSzocialisOsztondij",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.rendszeresSzocialisOsztondij) ? _vm._i(_vm.form.rendszeresSzocialisOsztondij, "1") > -1 : _vm._q(_vm.form.rendszeresSzocialisOsztondij, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.rendszeresSzocialisOsztondij,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.rendszeresSzocialisOsztondij = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.rendszeresSzocialisOsztondij = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.rendszeresSzocialisOsztondij = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper",
    class: {
      disabled: _vm.lakhatasiTamogatasDisabled()
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.lakhatasiTamogatas),
      expression: "form.lakhatasiTamogatas"
    }],
    attrs: {
      "disabled": _vm.lakhatasiTamogatasDisabled(),
      "id": "lakhatasiTamogatas",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.lakhatasiTamogatas) ? _vm._i(_vm.form.lakhatasiTamogatas, "1") > -1 : _vm._q(_vm.form.lakhatasiTamogatas, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.lakhatasiTamogatas,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.lakhatasiTamogatas = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.lakhatasiTamogatas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.lakhatasiTamogatas = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(7)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper",
    class: {
      disabled: _vm.koltsegteritesMerseklesDisabled()
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.koltsegteritesMersekles),
      expression: "form.koltsegteritesMersekles"
    }],
    attrs: {
      "disabled": _vm.koltsegteritesMerseklesDisabled(),
      "id": "koltsegteritesMersekles",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.koltsegteritesMersekles) ? _vm._i(_vm.form.koltsegteritesMersekles, "1") > -1 : _vm._q(_vm.form.koltsegteritesMersekles, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.koltsegteritesMersekles,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.koltsegteritesMersekles = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.koltsegteritesMersekles = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.koltsegteritesMersekles = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper",
    class: {
      disabled: _vm.koltsegteritesMerseklesSzocialisAlaponDisabled()
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.koltsegteritesMerseklesSzocialisAlapon),
      expression: "form.koltsegteritesMerseklesSzocialisAlapon"
    }],
    attrs: {
      "disabled": _vm.koltsegteritesMerseklesSzocialisAlaponDisabled(),
      "id": "koltsegteritesMerseklesSzocialisAlapon",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.koltsegteritesMerseklesSzocialisAlapon) ? _vm._i(_vm.form.koltsegteritesMerseklesSzocialisAlapon, "1") > -1 : _vm._q(_vm.form.koltsegteritesMerseklesSzocialisAlapon, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.koltsegteritesMerseklesSzocialisAlapon,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.koltsegteritesMerseklesSzocialisAlapon = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.koltsegteritesMerseklesSzocialisAlapon = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.koltsegteritesMerseklesSzocialisAlapon = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(9)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper disabled"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.onkoltsegesKollegiumiPontszam),
      expression: "form.onkoltsegesKollegiumiPontszam"
    }],
    attrs: {
      "disabled": true,
      "id": "onkoltsegesKollegiumiPontszam",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.onkoltsegesKollegiumiPontszam) ? _vm._i(_vm.form.onkoltsegesKollegiumiPontszam, "1") > -1 : _vm._q(_vm.form.onkoltsegesKollegiumiPontszam, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.onkoltsegesKollegiumiPontszam,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.onkoltsegesKollegiumiPontszam = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.onkoltsegesKollegiumiPontszam = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.onkoltsegesKollegiumiPontszam = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(10)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.koltsegteritesMersekles == 1 ? true : false),
      expression: "form.koltsegteritesMersekles == 1 ? true : false"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "koltsegteritesMerseklesKiemelkedoTevekenysegIgazolasa",
      "label": "Kiemelkedő tevékenység igazolása a költségtérítés mérsékléshez",
      "name": "koltsegteritesMerseklesKiemelkedoTevekenysegIgazolasa",
      "loaded_files": _vm.form.koltsegteritesMerseklesKiemelkedoTevekenysegIgazolasa
    },
    on: {
      "change": function (value) {
        _vm.form.koltsegteritesMerseklesKiemelkedoTevekenysegIgazolasa = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "errors": _vm.errors,
      "id": "koltsegteritesMerseklesIndoklas",
      "label": "Költségtérítés mérséklési kérelem indoklása",
      "name": "koltsegteritesMerseklesIndoklas"
    },
    model: {
      value: (_vm.form.koltsegteritesMerseklesIndoklas),
      callback: function($$v) {
        _vm.form.koltsegteritesMerseklesIndoklas = $$v
      },
      expression: "form.koltsegteritesMerseklesIndoklas"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "allandoLakhelyOrszag",
      "name": "allandoLakhelyOrszag",
      "disabled": "",
      "label": "Ország"
    },
    model: {
      value: (_vm.form.allandoLakhelyOrszag),
      callback: function($$v) {
        _vm.form.allandoLakhelyOrszag = $$v
      },
      expression: "form.allandoLakhelyOrszag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "allandoLakhelyIranyitoszam",
      "name": "allandoLakhelyIranyitoszam",
      "disabled": "",
      "label": "Irányítószám"
    },
    model: {
      value: (_vm.form.allandoLakhelyIranyitoszam),
      callback: function($$v) {
        _vm.form.allandoLakhelyIranyitoszam = $$v
      },
      expression: "form.allandoLakhelyIranyitoszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "allandoLakhelyTelepules",
      "name": "allandoLakhelyTelepules",
      "disabled": "",
      "label": "Település"
    },
    model: {
      value: (_vm.form.allandoLakhelyTelepules),
      callback: function($$v) {
        _vm.form.allandoLakhelyTelepules = $$v
      },
      expression: "form.allandoLakhelyTelepules"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "allandoLakhelyCim",
      "name": "allandoLakhelyCim",
      "disabled": "",
      "label": "Cím"
    },
    model: {
      value: (_vm.form.allandoLakhelyCim),
      callback: function($$v) {
        _vm.form.allandoLakhelyCim = $$v
      },
      expression: "form.allandoLakhelyCim"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "allandoLakhelyTavolsagKepzesHelyetolKm",
      "name": "allandoLakhelyTavolsagKepzesHelyetolKm",
      "disabled": "",
      "label": "Állandó lakhely távolsága (km) a képzés helyétől"
    },
    model: {
      value: (_vm.form.allandoLakhelyTavolsagKepzesHelyetolKm),
      callback: function($$v) {
        _vm.form.allandoLakhelyTavolsagKepzesHelyetolKm = $$v
      },
      expression: "form.allandoLakhelyTavolsagKepzesHelyetolKm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "utazasiIdoAllandoLakhelyKepzesHelyetolOra",
      "name": "utazasiIdoAllandoLakhelyKepzesHelyetolOra",
      "disabled": "",
      "label": "Utazási idő (óra) az állandó lakhelytől a képzés helyéig"
    },
    model: {
      value: (_vm.form.utazasiIdoAllandoLakhelyKepzesHelyetolOra),
      callback: function($$v) {
        _vm.form.utazasiIdoAllandoLakhelyKepzesHelyetolOra = $$v
      },
      expression: "form.utazasiIdoAllandoLakhelyKepzesHelyetolOra"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "utazasiIdoAllandoLakhelyKepzesHelyetolPerc",
      "name": "utazasiIdoAllandoLakhelyKepzesHelyetolPerc",
      "disabled": "",
      "label": "Utazási idő (perc) az állandó lakhelytől a képzés helyéig"
    },
    model: {
      value: (_vm.form.utazasiIdoAllandoLakhelyKepzesHelyetolPerc),
      callback: function($$v) {
        _vm.form.utazasiIdoAllandoLakhelyKepzesHelyetolPerc = $$v
      },
      expression: "form.utazasiIdoAllandoLakhelyKepzesHelyetolPerc"
    }
  })], 1), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "egyhaztartasbanElokIgazolas",
      "label": "Hatósági igazolás az egy háztartásban élőkről",
      "name": "egyhaztartasbanElokIgazolas",
      "loaded_files": _vm.form.egyhaztartasbanElokIgazolas
    },
    on: {
      "change": function (value) {
        _vm.form.egyhaztartasbanElokIgazolas = value;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.kollegiumiFerohely == 1 ? false : true),
      expression: "form.kollegiumiFerohely == 1 ? false : true"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.lakhatasiCeluAlberletiSzezodes),
      expression: "form.lakhatasiCeluAlberletiSzezodes"
    }],
    attrs: {
      "id": "lakhatasiCeluAlberletiSzezodes",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.lakhatasiCeluAlberletiSzezodes) ? _vm._i(_vm.form.lakhatasiCeluAlberletiSzezodes, "1") > -1 : _vm._q(_vm.form.lakhatasiCeluAlberletiSzezodes, "1")
    },
    on: {
      "change": function () {
        _vm.lakhatasiTamogatasJeloles();
      },
      "__c": function($event) {
        var $$a = _vm.form.lakhatasiCeluAlberletiSzezodes,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.lakhatasiCeluAlberletiSzezodes = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.lakhatasiCeluAlberletiSzezodes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.lakhatasiCeluAlberletiSzezodes = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return (error.id == 'lakhatasiCeluAlberletiSzezodes') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.lakhatasiCeluAlberletiSzezodes == 1 && _vm.form.kollegiumiFerohely == 0 ? true : false),
      expression: "form.lakhatasiCeluAlberletiSzezodes == 1 && form.kollegiumiFerohely == 0 ? true : false"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "lakhatasiCeluAlberletiSzezodesIgazolas",
      "label": "Albérleti szerződés igazolás",
      "name": "lakhatasiCeluAlberletiSzezodesIgazolas",
      "loaded_files": _vm.form.lakhatasiCeluAlberletiSzezodesIgazolas
    },
    on: {
      "change": function (value) {
        _vm.form.lakhatasiCeluAlberletiSzezodesIgazolas = value;
        _vm.lakhatasiTamogatasJeloles();
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper disabled"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.kollegiumiFerohely),
      expression: "form.kollegiumiFerohely"
    }],
    attrs: {
      "disabled": "",
      "true-value": "1",
      "false-value": "0",
      "id": "kollegiumiFerohely",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.kollegiumiFerohely) ? _vm._i(_vm.form.kollegiumiFerohely, "1") > -1 : _vm._q(_vm.form.kollegiumiFerohely, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.kollegiumiFerohely,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.kollegiumiFerohely = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.kollegiumiFerohely = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.kollegiumiFerohely = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(14)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.szocialisRaszorultsagArva),
      expression: "form.szocialisRaszorultsagArva"
    }],
    attrs: {
      "id": "szocialisRaszorultsagArva",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.szocialisRaszorultsagArva) ? _vm._i(_vm.form.szocialisRaszorultsagArva, "1") > -1 : _vm._q(_vm.form.szocialisRaszorultsagArva, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.szocialisRaszorultsagArva,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.szocialisRaszorultsagArva = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.szocialisRaszorultsagArva = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.szocialisRaszorultsagArva = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(16)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.szocialisRaszorultsagFelarva),
      expression: "form.szocialisRaszorultsagFelarva"
    }],
    attrs: {
      "id": "szocialisRaszorultsagFelarva",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.szocialisRaszorultsagFelarva) ? _vm._i(_vm.form.szocialisRaszorultsagFelarva, "1") > -1 : _vm._q(_vm.form.szocialisRaszorultsagFelarva, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.szocialisRaszorultsagFelarva,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.szocialisRaszorultsagFelarva = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.szocialisRaszorultsagFelarva = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.szocialisRaszorultsagFelarva = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(17)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.szocialisRaszorultsagCsaladfenntarto),
      expression: "form.szocialisRaszorultsagCsaladfenntarto"
    }],
    attrs: {
      "id": "szocialisRaszorultsagCsaladfenntarto",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.szocialisRaszorultsagCsaladfenntarto) ? _vm._i(_vm.form.szocialisRaszorultsagCsaladfenntarto, "1") > -1 : _vm._q(_vm.form.szocialisRaszorultsagCsaladfenntarto, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.szocialisRaszorultsagCsaladfenntarto,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.szocialisRaszorultsagCsaladfenntarto = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.szocialisRaszorultsagCsaladfenntarto = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.szocialisRaszorultsagCsaladfenntarto = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(18)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.szocialisRaszorultsagGyamsagaMegszunt),
      expression: "form.szocialisRaszorultsagGyamsagaMegszunt"
    }],
    attrs: {
      "id": "szocialisRaszorultsagGyamsagaMegszunt",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.szocialisRaszorultsagGyamsagaMegszunt) ? _vm._i(_vm.form.szocialisRaszorultsagGyamsagaMegszunt, "1") > -1 : _vm._q(_vm.form.szocialisRaszorultsagGyamsagaMegszunt, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.szocialisRaszorultsagGyamsagaMegszunt,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.szocialisRaszorultsagGyamsagaMegszunt = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.szocialisRaszorultsagGyamsagaMegszunt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.szocialisRaszorultsagGyamsagaMegszunt = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(19)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.szocialisRaszorultsagHatranyosHelyzetu),
      expression: "form.szocialisRaszorultsagHatranyosHelyzetu"
    }],
    attrs: {
      "id": "szocialisRaszorultsagHatranyosHelyzetu",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.szocialisRaszorultsagHatranyosHelyzetu) ? _vm._i(_vm.form.szocialisRaszorultsagHatranyosHelyzetu, "1") > -1 : _vm._q(_vm.form.szocialisRaszorultsagHatranyosHelyzetu, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.szocialisRaszorultsagHatranyosHelyzetu,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.szocialisRaszorultsagHatranyosHelyzetu = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.szocialisRaszorultsagHatranyosHelyzetu = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.szocialisRaszorultsagHatranyosHelyzetu = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(20)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.szocialisRaszorultsagFogyatkossaggalElo),
      expression: "form.szocialisRaszorultsagFogyatkossaggalElo"
    }],
    attrs: {
      "id": "szocialisRaszorultsagFogyatkossaggalElo",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.szocialisRaszorultsagFogyatkossaggalElo) ? _vm._i(_vm.form.szocialisRaszorultsagFogyatkossaggalElo, "1") > -1 : _vm._q(_vm.form.szocialisRaszorultsagFogyatkossaggalElo, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.szocialisRaszorultsagFogyatkossaggalElo,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.szocialisRaszorultsagFogyatkossaggalElo = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.szocialisRaszorultsagFogyatkossaggalElo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.szocialisRaszorultsagFogyatkossaggalElo = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(21)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.szocialisRaszorultsagHalmozottanHatranyosHelyzetu),
      expression: "form.szocialisRaszorultsagHalmozottanHatranyosHelyzetu"
    }],
    attrs: {
      "id": "szocialisRaszorultsagHalmozottanHatranyosHelyzetu",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.szocialisRaszorultsagHalmozottanHatranyosHelyzetu) ? _vm._i(_vm.form.szocialisRaszorultsagHalmozottanHatranyosHelyzetu, "1") > -1 : _vm._q(_vm.form.szocialisRaszorultsagHalmozottanHatranyosHelyzetu, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.szocialisRaszorultsagHalmozottanHatranyosHelyzetu,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.szocialisRaszorultsagHalmozottanHatranyosHelyzetu = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.szocialisRaszorultsagHalmozottanHatranyosHelyzetu = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.szocialisRaszorultsagHalmozottanHatranyosHelyzetu = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(22)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.szocialisRaszorultsagTartosBeteg),
      expression: "form.szocialisRaszorultsagTartosBeteg"
    }],
    attrs: {
      "id": "szocialisRaszorultsagTartosBeteg",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.szocialisRaszorultsagTartosBeteg) ? _vm._i(_vm.form.szocialisRaszorultsagTartosBeteg, "1") > -1 : _vm._q(_vm.form.szocialisRaszorultsagTartosBeteg, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.szocialisRaszorultsagTartosBeteg,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.szocialisRaszorultsagTartosBeteg = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.szocialisRaszorultsagTartosBeteg = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.szocialisRaszorultsagTartosBeteg = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(23)]), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return (error.id == 'szocialisRaszorultsagTartosBeteg') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper disabled"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.szocialisRaszorultsagNagycsalados),
      expression: "form.szocialisRaszorultsagNagycsalados"
    }],
    attrs: {
      "disabled": true,
      "id": "szocialisRaszorultsagNagycsalados",
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.szocialisRaszorultsagNagycsalados) ? _vm._i(_vm.form.szocialisRaszorultsagNagycsalados, "1") > -1 : _vm._q(_vm.form.szocialisRaszorultsagNagycsalados, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.szocialisRaszorultsagNagycsalados,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.szocialisRaszorultsagNagycsalados = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.szocialisRaszorultsagNagycsalados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.szocialisRaszorultsagNagycsalados = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(24)]), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return (error.id == 'szocialisRaszorultsagNagycsalados') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.szocialisRaszorultsagNagycsalados == 1 ? true : false),
      expression: "form.szocialisRaszorultsagNagycsalados == 1 ? true : false"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n            A nagycsaládos helyzet igazolásához legalább két eltartott testvér esetén születési anyakönyvi kivonat, diákigazolvány másolat vagy hallgatói jogviszony igazolás szükséges; három gyermek esetén az anyakönyvi kivonatok másolatai szükségesek; eltartóin (eltartóján) kívül legalább két vele egy háztartásban élő személyre igaz, hogy havi jövedelme nem éri el a minimálbér összegét, mely esetén jövedelemigazolások szükségesek, vagy igazolás arról, hogy nem rendelkezik jövedelemmel (például: kiskorú, tanuló, hallgató munkanélküli); legalább két kiskorú gyermeknek a gyámja, mely esetén gyámsági igazolás szükséges.\n          ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.szocialisRaszorultsagArva == 1 ? true : false),
      expression: "form.szocialisRaszorultsagArva == 1 ? true : false"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "szocialisRaszorultsagArvaIgazolas",
      "label": "Árva igazolás",
      "name": "szocialisRaszorultsagArvaIgazolas",
      "loaded_files": _vm.form.szocialisRaszorultsagArvaIgazolas
    },
    on: {
      "change": function (value) {
        _vm.form.szocialisRaszorultsagArvaIgazolas = value;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.szocialisRaszorultsagFelarva == 1 ? true : false),
      expression: "form.szocialisRaszorultsagFelarva == 1 ? true : false"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "szocialisRaszorultsagFelarvaIgazolas",
      "label": "Félárva igazolás",
      "name": "szocialisRaszorultsagFelarvaIgazolas",
      "loaded_files": _vm.form.szocialisRaszorultsagFelarvaIgazolas
    },
    on: {
      "change": function (value) {
        _vm.form.szocialisRaszorultsagFelarvaIgazolas = value;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.szocialisRaszorultsagCsaladfenntarto == 1 ? true : false),
      expression: "form.szocialisRaszorultsagCsaladfenntarto == 1 ? true : false"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "szocialisRaszorultsagCsaladfenntartoIgazolas",
      "label": "Családfenntartó igazolás",
      "name": "szocialisRaszorultsagCsaladfenntartoIgazolas",
      "loaded_files": _vm.form.szocialisRaszorultsagCsaladfenntartoIgazolas
    },
    on: {
      "change": function (value) {
        _vm.form.szocialisRaszorultsagCsaladfenntartoIgazolas = value;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.szocialisRaszorultsagGyamsagaMegszunt == 1 ? true : false),
      expression: "form.szocialisRaszorultsagGyamsagaMegszunt == 1 ? true : false"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "szocialisRaszorultsagGyamsagaMegszuntIgazolas",
      "label": "Gyámsága nagykorúsága miatt szűnt meg igazolás",
      "name": "szocialisRaszorultsagGyamsagaMegszuntIgazolas",
      "loaded_files": _vm.form.szocialisRaszorultsagGyamsagaMegszuntIgazolas
    },
    on: {
      "change": function (value) {
        _vm.form.szocialisRaszorultsagGyamsagaMegszuntIgazolas = value;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.szocialisRaszorultsagHatranyosHelyzetu == 1 ? true : false),
      expression: "form.szocialisRaszorultsagHatranyosHelyzetu == 1 ? true : false"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "szocialisRaszorultsagHatranyosHelyzetuIgazolas",
      "label": "Hátrányos helyzetű igazolás",
      "name": "szocialisRaszorultsagHatranyosHelyzetuIgazolas",
      "loaded_files": _vm.form.szocialisRaszorultsagHatranyosHelyzetuIgazolas
    },
    on: {
      "change": function (value) {
        _vm.form.szocialisRaszorultsagHatranyosHelyzetuIgazolas = value;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.szocialisRaszorultsagFogyatkossaggalElo == 1 ? true : false),
      expression: "form.szocialisRaszorultsagFogyatkossaggalElo == 1 ? true : false"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "szocialisRaszorultsagFogyatkossaggalEloIgazolas",
      "label": "Fogyatékossággal élő igazolás",
      "name": "szocialisRaszorultsagFogyatkossaggalEloIgazolas",
      "loaded_files": _vm.form.szocialisRaszorultsagFogyatkossaggalEloIgazolas
    },
    on: {
      "change": function (value) {
        _vm.form.szocialisRaszorultsagFogyatkossaggalEloIgazolas = value;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.szocialisRaszorultsagHalmozottanHatranyosHelyzetu == 1 ? true : false),
      expression: "form.szocialisRaszorultsagHalmozottanHatranyosHelyzetu == 1 ? true : false"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "szocialisRaszorultsagHalmozottanHatranyosHelyzetuIgazolas",
      "label": "Halmozottan hátrányos helyzetű igazolás",
      "name": "szocialisRaszorultsagHalmozottanHatranyosHelyzetuIgazolas",
      "loaded_files": _vm.form.szocialisRaszorultsagHalmozottanHatranyosHelyzetuIgazolas
    },
    on: {
      "change": function (value) {
        _vm.form.szocialisRaszorultsagHalmozottanHatranyosHelyzetuIgazolas = value;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.szocialisRaszorultsagTartosBeteg == 1 ? true : false),
      expression: "form.szocialisRaszorultsagTartosBeteg == 1 ? true : false"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "szocialisRaszorultsagTartosBetegIgazolas",
      "label": "Tartós beteg igazolás",
      "name": "szocialisRaszorultsagTartosBetegIgazolas",
      "loaded_files": _vm.form.szocialisRaszorultsagTartosBetegIgazolas
    },
    on: {
      "change": function (value) {
        _vm.form.szocialisRaszorultsagTartosBetegIgazolas = value;
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n            " + _vm._s(_vm.konfigAdat('EURO_ARFOLYAM').megnevezes) + ": "), _c('strong', [_vm._v(_vm._s(_vm.konfigAdat('EURO_ARFOLYAM').ertek_) + " Ft")]), _c('br'), _vm._v("\n            " + _vm._s(_vm.konfigAdat('DOLLAR_ARFOLYAM').megnevezes) + ": "), _c('strong', [_vm._v(_vm._s(_vm.konfigAdat('DOLLAR_ARFOLYAM').ertek_) + " Ft")]), _c('br'), _vm._v("\n            " + _vm._s(_vm.konfigAdat('MINIMALBER').megnevezes) + ": "), _c('strong', [_vm._v(_vm._s(_vm.konfigAdat('MINIMALBER').ertek_) + " Ft")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "list-table"
  }, [_vm._m(26), _vm._v(" "), _vm._l((_vm.form.kozosHaztartasbanElokLista), function(kozoshaztartasbanElo, i) {
    return _c('tr', {
      key: 'kozoshaztartasbanElo_' + i
    }, [_c('td', [_c('inputbox', {
      staticStyle: {
        "padding-bottom": "0px"
      },
      attrs: {
        "disabled": i == 0,
        "errors": _vm.errors,
        "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+",
        "id": 'nev_' + i,
        "label": "",
        "name": 'nev_' + i
      },
      model: {
        value: (kozoshaztartasbanElo.nev),
        callback: function($$v) {
          kozoshaztartasbanElo.nev = $$v
        },
        expression: "kozoshaztartasbanElo.nev"
      }
    })], 1), _vm._v(" "), _c('td', [_c('inputbox', {
      staticStyle: {
        "padding-bottom": "0px"
      },
      attrs: {
        "disabled": i == 0,
        "errors": _vm.errors,
        "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ ]+",
        "id": 'rokonsagiFok_' + i,
        "label": "",
        "name": 'rokonsagiFok_' + i
      },
      model: {
        value: (kozoshaztartasbanElo.rokonsagiFok),
        callback: function($$v) {
          kozoshaztartasbanElo.rokonsagiFok = $$v
        },
        expression: "kozoshaztartasbanElo.rokonsagiFok"
      }
    })], 1), _vm._v(" "), _c('td', [_c('comboboxV2', {
      staticStyle: {
        "padding-bottom": "0px"
      },
      attrs: {
        "disabled": i == 0,
        "errors": _vm.errors,
        "label": "",
        "id": 'foglalkozas_' + i,
        "options": _vm.foglalkozas_tipusok
      },
      model: {
        value: (kozoshaztartasbanElo.tipus),
        callback: function($$v) {
          kozoshaztartasbanElo.tipus = $$v
        },
        expression: "kozoshaztartasbanElo.tipus"
      }
    })], 1), _vm._v(" "), _c('td', [_c('inputbox', {
      staticStyle: {
        "padding-bottom": "0px"
      },
      attrs: {
        "regexp_filter": "[0-9]+",
        "id": 'haviNettoJovedelem_' + i,
        "errors": _vm.errors,
        "label": "",
        "name": 'haviNettoJovedelem_' + i
      },
      on: {
        "input": _vm.egyForeJutoNettoHaviJovedelemKalkulacio
      },
      model: {
        value: (kozoshaztartasbanElo.haviNettoJovedelem),
        callback: function($$v) {
          kozoshaztartasbanElo.haviNettoJovedelem = $$v
        },
        expression: "kozoshaztartasbanElo.haviNettoJovedelem"
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-checkbox-wrapper",
      class: {
        disabled: i == 0 ? true : false
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kozoshaztartasbanElo.nemElVelemEgyHaztartasban),
        expression: "kozoshaztartasbanElo.nemElVelemEgyHaztartasban"
      }],
      attrs: {
        "disabled": i == 0,
        "id": 'nemElVelemEgyHaztartasban_' + i,
        "true-value": "1",
        "false-value": "0",
        "type": "checkbox",
        "value": "0"
      },
      domProps: {
        "checked": Array.isArray(kozoshaztartasbanElo.nemElVelemEgyHaztartasban) ? _vm._i(kozoshaztartasbanElo.nemElVelemEgyHaztartasban, "0") > -1 : _vm._q(kozoshaztartasbanElo.nemElVelemEgyHaztartasban, "1")
      },
      on: {
        "change": _vm.egyForeJutoNettoHaviJovedelemKalkulacio,
        "__c": function($event) {
          var $$a = kozoshaztartasbanElo.nemElVelemEgyHaztartasban,
            $$el = $event.target,
            $$c = $$el.checked ? ("1") : ("0");
          if (Array.isArray($$a)) {
            var $$v = "0",
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (kozoshaztartasbanElo.nemElVelemEgyHaztartasban = $$a.concat($$v))
            } else {
              $$i > -1 && (kozoshaztartasbanElo.nemElVelemEgyHaztartasban = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            kozoshaztartasbanElo.nemElVelemEgyHaztartasban = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'nemElVelemEgyHaztartasban_' + i
      }
    }, [_c('div', {
      staticClass: "icon"
    })])])]), _vm._v(" "), _c('td', [(i > 0) ? _c('button', {
      staticClass: "button only-icon",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.kozosHaztartasbanElokListabolTorol(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "button only-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.kozosHaztartasbanElokListahozHozzaad
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "disabled": true,
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "id": "egyForeJutoNettoHaviJovedelem",
      "label": "Egy főre jutó nettó havi jövedelem (Ft)",
      "name": "egyForeJutoNettoHaviJovedelem"
    },
    model: {
      value: (_vm.form.egyForeJutoNettoHaviJovedelem),
      callback: function($$v) {
        _vm.form.egyForeJutoNettoHaviJovedelem = $$v
      },
      expression: "form.egyForeJutoNettoHaviJovedelem"
    }
  })], 1), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": _vm.form.kozosHaztartasbanElokLista.length,
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "kozosHaztartasbanElokNettoJovedelmeIgazolas",
      "label": "Jövedelemigazolások, jogviszony igazolások, egyéb papírok",
      "name": "kozosHaztartasbanElokNettoJovedelmeIgazolas",
      "loaded_files": _vm.form.kozosHaztartasbanElokNettoJovedelmeIgazolas
    },
    on: {
      "change": function (value) {
        _vm.form.kozosHaztartasbanElokNettoJovedelmeIgazolas = value;
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.egeszsegugyiKiadasokMutat()),
      expression: "egeszsegugyiKiadasokMutat()"
    }],
    staticClass: "row"
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "id": "egeszsegugyiKiadasokPalyazoReszerol",
      "label": "Igazolt egészségügyi kiadások a pályázó részéről (Ft)",
      "name": "egeszsegugyiKiadasokPalyazoReszerol"
    },
    model: {
      value: (_vm.form.egeszsegugyiKiadasokPalyazoReszerol),
      callback: function($$v) {
        _vm.form.egeszsegugyiKiadasokPalyazoReszerol = $$v
      },
      expression: "form.egeszsegugyiKiadasokPalyazoReszerol"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "id": "egeszsegugyiKiadasokCsaladtagjaiReszerol",
      "label": "Igazolt egészségügyi kiadások a pályázó családtagjai részéről (Ft)",
      "name": "egeszsegugyiKiadasokCsaladtagjaiReszerol"
    },
    model: {
      value: (_vm.form.egeszsegugyiKiadasokCsaladtagjaiReszerol),
      callback: function($$v) {
        _vm.form.egeszsegugyiKiadasokCsaladtagjaiReszerol = $$v
      },
      expression: "form.egeszsegugyiKiadasokCsaladtagjaiReszerol"
    }
  })], 1), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "egeszsegugyiKiadasokPalyazoIgazolas",
      "label": "Egészségügyi kiadások pályázó részéről igazolás",
      "name": "egeszsegugyiKiadasokPalyazoIgazolas",
      "loaded_files": _vm.form.egeszsegugyiKiadasokPalyazoIgazolas
    },
    on: {
      "change": function (value) {
        _vm.form.egeszsegugyiKiadasokPalyazoIgazolas = value;
      }
    }
  })], 1)]), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "egeszsegugyiKiadasokCsaladtagokIgazolas",
      "label": "Egészségügyi kiadások pályázó családtagjai részéről igazolás",
      "name": "egeszsegugyiKiadasokCsaladtagokIgazolas",
      "loaded_files": _vm.form.egeszsegugyiKiadasokCsaladtagokIgazolas
    },
    on: {
      "change": function (value) {
        _vm.form.egeszsegugyiKiadasokCsaladtagokIgazolas = value;
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "id": "megjegyzes",
      "label": "Megjegyzés",
      "name": "megjegyzes"
    },
    model: {
      value: (_vm.form.megjegyzes),
      callback: function($$v) {
        _vm.form.megjegyzes = $$v
      },
      expression: "form.megjegyzes"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nyilatkozatElfogadas),
      expression: "form.nyilatkozatElfogadas"
    }],
    attrs: {
      "true-value": "1",
      "false-value": "0",
      "id": "nyilatkozatElfogadas",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.nyilatkozatElfogadas) ? _vm._i(_vm.form.nyilatkozatElfogadas, null) > -1 : _vm._q(_vm.form.nyilatkozatElfogadas, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.nyilatkozatElfogadas,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.nyilatkozatElfogadas = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.nyilatkozatElfogadas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.nyilatkozatElfogadas = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(33)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'nyilatkozatElfogadas') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nyilatkozatElfogadas_),
      expression: "form.nyilatkozatElfogadas_"
    }],
    attrs: {
      "true-value": "1",
      "false-value": "0",
      "id": "nyilatkozatElfogadas_",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.nyilatkozatElfogadas_) ? _vm._i(_vm.form.nyilatkozatElfogadas_, null) > -1 : _vm._q(_vm.form.nyilatkozatElfogadas_, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.nyilatkozatElfogadas_,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.nyilatkozatElfogadas_ = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.nyilatkozatElfogadas_ = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.nyilatkozatElfogadas_ = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(34)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'nyilatkozatElfogadas_') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.szoctamKisokosElolvasasa),
      expression: "form.szoctamKisokosElolvasasa"
    }],
    attrs: {
      "true-value": "1",
      "false-value": "0",
      "id": "szoctamKisokosElolvasasa",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.szoctamKisokosElolvasasa) ? _vm._i(_vm.form.szoctamKisokosElolvasasa, null) > -1 : _vm._q(_vm.form.szoctamKisokosElolvasasa, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.szoctamKisokosElolvasasa,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.szoctamKisokosElolvasasa = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.szoctamKisokosElolvasasa = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.szoctamKisokosElolvasasa = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(35)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'szoctamKisokosElolvasasa') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.mentes_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.preSave(0)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.mentes_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.preSave(1)
      }
    }
  }, [_vm._v("Véglegesít")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nezet.tipus == 'hianypotlas_urlap'),
      expression: "nezet.tipus == 'hianypotlas_urlap'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("\n            Rendszeres szociális ösztöndíj hiánypótlás (" + _vm._s(_vm.aktiv_hianypotlas_idoszak) + ")\n          ")])])]), _vm._v(" "), _vm._l((_vm.hianypotlas_mezok), function(mezo, i) {
    return _c('div', [_c('div', {
      staticClass: "info-box warning",
      domProps: {
        "innerHTML": _vm._s(mezo.megjegyzes)
      }
    }), _vm._v(" "), _c('UploadHandler', {
      key: 'hp_' + mezo.id,
      attrs: {
        "max_uploaded_files": 10,
        "accepted_files": 'image/jpeg,application/pdf,application/x-pdf',
        "errors": _vm.errors,
        "id": 'hp_' + mezo.id,
        "label": mezo.megnevezes,
        "name": 'hp_' + mezo.id
      },
      on: {
        "change": function (value) {
          mezo.fajlok = value;
        }
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.mentes_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hianypotlasBekuldes()
      }
    }
  }, [_vm._v("Beküldés")])])])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nezet.tipus == 'info'),
      expression: "nezet.tipus == 'info'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("\n            Rendszeres szociális ösztöndíj\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.nezet.tartalom)
    }
  })])])])]), _vm._v(" "), (_vm.email_popup.mutat) ? _c('div', {
    staticClass: "popup-overlay-v2"
  }, [_c('div', {
    staticClass: "popup-overlay-v2-inner"
  }, [_c('div', {
    staticClass: "popup-overlay-v2-inner-content"
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('button', {
    staticClass: "close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.emailPopupZar
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('h1', [_vm._v("Email tartalma")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.email_popup.tartalom)
    }
  })])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("\n            Rendszeres szociális ösztöndíj\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n            Amennyiben hibát talál "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("személyes")]), _vm._v(" vagy "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("képzési adataiban")]), _vm._v(", kérjük lépjen kapcsolatba a tanulmányi ügyintézővel.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Személyes adatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Képzési adatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Igényelt támogatások\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "alapTamogatas"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Alaptámogatás\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "rendszeresSzocialisOsztondij"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Rendszeres szociális ösztöndíj\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "lakhatasiTamogatas"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Lakhatási támogatás\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "koltsegteritesMersekles"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Költségtérítés-mérséklés tevékenység alapon\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "koltsegteritesMerseklesSzocialisAlapon"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Költségtérítés-mérséklés szociális alapon\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "onkoltsegesKollegiumiPontszam"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Önköltségeseknek kollégiumi pontszám\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            A pályázó állandó lakhelyének távolsága a képzés helyétől\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/rendszeres_szocialis_osztondij_1_sz_melleklet.pdf",
      "title": "1. sz. melléklet"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("1. sz. melléklet (Kérelem egy lakcímen bejelentett személyek igazolásához minta)")]), _vm._v(" letöltés\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "lakhatasiCeluAlberletiSzezodes"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Lakhatási célú albérleti szerződéssel rendelkezem\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "kollegiumiFerohely"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Kollégiumi férőhely\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Szociális rászorultság - családi állapot\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "szocialisRaszorultsagArva"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Árva\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "szocialisRaszorultsagFelarva"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Félárva\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "szocialisRaszorultsagCsaladfenntarto"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Családfenntartó\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "szocialisRaszorultsagGyamsagaMegszunt"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Gyámsága nagykorúsága miatt szűnt meg\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "szocialisRaszorultsagHatranyosHelyzetu"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Hátrányos helyzetű\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "szocialisRaszorultsagFogyatkossaggalElo"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Fogyatékossággal élő\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "szocialisRaszorultsagHalmozottanHatranyosHelyzetu"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Halmozottan hátrányos helyzetű\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "szocialisRaszorultsagTartosBeteg"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Tartós beteg\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "szocialisRaszorultsagNagycsalados"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Nagycsaládos\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Pályázóval közös háztartásban élők havi nettó jövedelme\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Teljes név")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Rokonsági fok")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Foglalkozás")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Havi nettó jövedelem (Ft)")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Nem él velem"), _c('br'), _vm._v("egy háztartásban")]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/rendszeres_szocialis_osztondij_2_sz_melleklet.pdf",
      "title": "2. sz melléklet"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("2. sz melléklet (Nyilatkozat minta)")]), _vm._v(" letöltés\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Egészségügyi kiadások\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/rendszeres_szocialis_osztondij_3_sz_melleklet.pdf",
      "title": "3. sz melléklet"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("3. sz melléklet (Szakorvosi vélemény (pályázó) minta)")]), _vm._v(" letöltés\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/rendszeres_szocialis_osztondij_4_sz_melleklet.pdf",
      "title": "4. sz melléklet"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("4. sz melléklet (Szakorvosi vélemény (hozzátartozó) minta)")]), _vm._v(" letöltés\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Megjegyzés\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Hallgatói nyiltakozat\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "nyilatkozatElfogadas"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Büntetőjogi felelősségem teljes tudatában kijelentem, hogy a saját és a hozzátartozóim, illetve a velem egy háztartásban élők jelen adatlapon, valamint a mellékletekben feltüntetett személyes adatai a valóságnak megfelelnek.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "nyilatkozatElfogadas_"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Tudomásul veszem, hogy a hamis adatok közlése esetén fegyelmi eljárás indulhat ellenem a vonatkozó jogszabályok és a Széchenyi István Egyetem belső szabályzatai alapján, mely a hallgatói jogviszony fegyelmi úton történő megszűnését is eredményezheti.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "szoctamKisokosElolvasasa"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', [_vm._v("\n                  Elolvastam a "), _c('strong', [_vm._v("Szoctám Kisokos Hallgatóknak")]), _vm._v(" című tájékoztatót. A dokumentum az alábbi "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://student.sze.hu/downloadmanager/details/id/45580/m/16718"
    }
  }, [_vm._v("linkről")]), _vm._v(" tölthető le.\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b039553c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/rendszeres_szocialis_osztondij.vue
// module id = 397
// module chunks = 0